// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTemplate_container__1xtS6","main":"PageTemplate_main__2LGJj","content":"PageTemplate_content__3gmWb"};